import { createApp } from '@app/adapters/create-app'

import SaveChanges from '../components/save-changes.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='save-changes-btn']").each(function () {
    createApp(SaveChanges).mount(this)
  })
})
